<template>
    <div class="col-md-12">
        <!-- Información del producto -->
         <div class="row">
            <div class="col-md-12">
                <h5 class="text-primary">{{ store.productoNombre }}</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Aseguradora</label>
                    <p class="text-primary">{{ store.aseguradoraNombre }}</p>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Producto</label>
                    <p class="text-primary">{{ store.productoNombre }}</p>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Deducible</label>
                    <select class="form-control" required="required" :disabled="!deduciblesDisponibles.length" v-model="store.deducible">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option v-for="deducible in deduciblesDisponibles" :key="deducible" :value="deducible">
                            {{ formatCurrency(deducible) }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Frecuencia de pago</label>
                    <select class="form-control" required="required" v-model="store.periodoPago">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option value="24">Quincenal</option>
                        <option value="12">Mensual</option>
                        <option value="4">Trimestral</option>
                        <option value="2">Semestral</option>
                        <option value="1">Anual</option>
                    </select>
                </div>
            </div>
        </div>

        <DerechoPolizaAviso />

        <!-- Tabla de asegurados -->
        <div class="row mt-3">
            <table class="table table-bordered table-hover">
                <thead>
                    <tr class="table-secondary">
                        <th class="text-begin">Nombre</th>
                        <th class="text-center">Edad</th>
                        <th class="text-center">Género</th>
                        <th class="text-center">Parentesco</th>
                        <th class="text-end">Fecha antiguedad</th>
                        <th class="text-end">Fecha alta</th>
                        <th class="text-end">Fecha baja</th>
                        <th class="text-end">Prima</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="asegurado in store.asegurados" :key="asegurado.id">
                        <td>{{ asegurado.nombre }} {{ asegurado.paterno }} {{ asegurado.materno }}</td>
                        <td class="text-center">{{ asegurado.edad }}</td>
                        <td class="text-center">{{ asegurado.genero }}</td>
                        <td class="text-center">{{ asegurado.parentesco }}</td>
                        <td class="text-end">{{ asegurado.antiguedad }}</td>
                        <td class="text-end">{{ asegurado.fechaAlta }}</td>
                        <td class="text-end">{{ asegurado.fechaFin }}</td>
                        <td class="text-end">{{ formatCurrency(asegurado.prima) }}</td>
                    </tr>
                    <tr>
                        <td colspan="7">Prima neta</td>
                        <td class="text-end fw-bold">{{ formatCurrency(store.sumaPrimas) }}</td>
                    </tr>
                    <tr>
                        <td colspan="7">Derecho de póliza</td>
                        <td class="text-end">{{ derechoTexto }}</td>
                    </tr>
                    <tr>
                        <td colspan="7">IVA</td>
                        <td class="text-end">{{ formatCurrency(store.montoIva) }}</td>
                    </tr>
                    <tr class="table-secondary">
                        <td colspan="7" class="fw-bold">Prima total</td>
                        <td class="text-end fw-bold">{{ formatCurrency(store.primaTotal) }}</td>
                    </tr>
                    <tr>
                        <td colspan="7" class="text-primary fw-bold">Prima periódica</td>
                        <td class="text-end text-primary fw-bold">{{ formatCurrency(store.primaPeriodica) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="row mt-3">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Número de póliza</label>
                    <input class="form-control" type="text" placeholder="Ingrese el número de póliza" required="required" v-model="store.poliza">
                </div>
            </div>
           
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Inicio de vigencia</label>
                    <input class="form-control" type="date" required="required" v-model="store.inicioVigencia" @change="calculateDiasContratados">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Fin de vigencia</label>
                    <input class="form-control" type="date" required="required" v-model="store.finVigencia" @change="calculateDiasContratados">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Días contratados</label>
                    <input class="form-control" type="text" v-model="store.diasContratados" readonly>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Fecha de solicitud</label>
                    <input class="form-control" type="date" required="required" v-model="store.fechaSolicitud">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Suma asegurada</label>
                    <select class="form-control" required="required" v-model="store.sumaAsegurada">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option :value="100000000">$100,000,000.00</option>
                        <option value="Ilimitada">Ilimitada</option>
                    </select>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Coaseguro</label>
                    <input class="form-control" type="text" placeholder="10%" readonly required="required"
                        v-model="coaseguroFormatted" @blur="formatCoaseguro">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Tope de coaseguro</label>
                    <input class="form-control" type="text" placeholder="$60,000.00" readonly required="required"
                        v-model="store.topeCoaseguro">
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">Notas de orden de trabajo</label>
                    <textarea v-model="store.notasOrdenDeTrabajo" class="form-control" rows="3" style="resize: none;"
                        placeholder="Escriba aquí las notas que se integrarán a la orden de trabajo" required="required"></textarea>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">Observaciones internas</label>
                    <textarea v-model="store.observacionesInternas" class="form-control" rows="3" style="resize: none;"
                        placeholder="Escriba aquí sus observaciones y comentarios internos" required="required"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useSeguroStore } from '@/stores/seguroStore';
import DerechoPolizaAviso from './DerechoPolizaAviso.vue';
import api from '@/axios';

export default {
    name: 'FormularioGMM',
    components: { DerechoPolizaAviso },
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    data() {
        return {
            loading: false,
            error: null,
            coaseguroInput: '',
        };
    },
    computed: {
        derechoTexto() {
            return this.store.derechoPolizaEstado === 'ok' ? this.formatCurrency(this.store.derechoPoliza) : '—';
        },
        deduciblesDisponibles() {
            if (!this.store.tarifas || !this.store.tarifas.length) return [];
            const set = new Set(this.store.tarifas.map(t => t.deducible));
            return Array.from(set).sort((a, b) => a - b);
        },
        totalPrima() {
            if (!this.store.asegurados || !this.store.asegurados.length) return 0;
            return this.store.asegurados.reduce((sum, a) => sum + (parseFloat(a.prima) || 0), 0);
        },
        coaseguroFormatted: {
            get() {
                return this.coaseguroInput || (this.store.coaseguro ? String(this.store.coaseguro) : '');
            },
            set(value) {
                this.coaseguroInput = value;
                this.store.coaseguro = this.cleanCurrencyValue(value);
            },
        },
    },
    watch: {
        'store.aseguradoraId'(val) { if (val) this.store.updateAseguradoraNombre(); },
        'store.productoId'(newVal, oldVal) {
            if (newVal) this.store.updateProductoNombre();
            if (newVal && newVal !== oldVal) this.fetchTarifas();
        },
        'store.deducible'(val) { if (val) this.calcularPrimas(); },
        'store.asegurados': {
            handler() { if (this.store.deducible) this.calcularPrimas(); },
            deep: true,
        },
        totalPrima: {
            handler(val) {
                this.store.sumaPrimas = val;
                this.calcularPrimaTotal();
            },
            immediate: true,
        },
        'store.periodoPago'() { this.calcularPrimaTotal(); },
        'store.derechoPoliza'() { this.calcularPrimaTotal(); },
        'store.fechaSolicitud'() { this.store.cargarDerechoPoliza(); },
        'store.iva'() { this.calcularPrimaTotal(); },
    },
    mounted() {
        this.store.updateAseguradoraNombre();
        this.store.updateProductoNombre();
        if (this.store.productoId) this.fetchTarifas();
        this.store.cargarDerechoPoliza();
        if (this.store.coaseguro) this.coaseguroInput = this.formatCurrency(this.store.coaseguro);
    },
    methods: {
        cleanCurrencyValue(value) {
            if (!value) return 0;
            const numeric = parseFloat(String(value).replace(/[$,\s]/g, ''));
            return isNaN(numeric) ? 0 : numeric;
        },
        formatCoaseguro() {
            if (this.store.coaseguro) this.coaseguroInput = this.formatCurrency(this.store.coaseguro);
        },
        formatCurrency(value) {
            if (value == null || value === '') return '$0.00';
            return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);
        },
        async fetchTarifas() {
            if (!this.store.productoId) return;
            try {
                this.loading = true;
                this.error = null;
                const response = await api.get(`productos/${this.store.productoId}/detalles`);
                const data = response.data || {};
                if (data.producto) this.store.productoDetalle = data.producto;
                if (data.tarifas) this.store.tarifas = data.tarifas;
            } catch {
                this.error = 'No se pudieron cargar las tarifas.';
            } finally {
                this.loading = false;
            }
        },
        async calcularPrimas() {
            if (!this.store.productoId || !this.store.asegurados?.length || !this.store.deducible) return;
            try {
                this.loading = true;
                for (const asegurado of this.store.asegurados) {
                    if (!asegurado.edad) continue;
                    const tarifaLocal = this.store.tarifas.find(t => {
                        if (t.deducible != this.store.deducible) return false;
                        const [minStr, maxStr] = (t.edadRango || '').split('-');
                        return asegurado.edad >= parseInt(minStr) && asegurado.edad <= parseInt(maxStr);
                    });
                    asegurado.prima = tarifaLocal ? (tarifaLocal.tarifa || 0) : await this.fetchPrimaValue(asegurado);
                }
                this.store.sumaPrimas = this.totalPrima;
            } catch {
                this.error = 'No se pudieron calcular las primas.';
            } finally {
                this.loading = false;
            }
        },
        async fetchPrimaValue(asegurado) {
            try {
                const response = await api.get(
                    `tarifas/producto/${this.store.productoId}/deducible/${this.store.deducible}/edad/${asegurado.edad}`
                );
                const data = response.data || {};
                return data.tarifa ?? data.prima ?? 0;
            } catch {
                return 0;
            }
        },
        calculateDiasContratados() {
            if (!this.store.inicioVigencia || !this.store.finVigencia) {
                this.store.diasContratados = '';
                return;
            }
            const dias = Math.round((new Date(this.store.finVigencia) - new Date(this.store.inicioVigencia)) / (1000 * 60 * 60 * 24));
            this.store.diasContratados = dias >= 0 ? dias : 'Rango de fechas inválido';
        },
        calcularPrimaTotal() {
            const sumaPrimas = parseFloat(this.store.sumaPrimas) || 0;
            // Sin el derecho de póliza del año no se calcula el total (no se usa un monto supuesto).
            if (this.store.derechoPoliza == null) {
                this.store.montoIva = 0;
                this.store.primaTotal = 0;
                this.store.primaPeriodica = 0;
                return;
            }
            const derechoPoliza = parseFloat(this.store.derechoPoliza) || 0;
            const tasaIva = parseFloat(this.store.iva) || 0;
            const subtotal = sumaPrimas + derechoPoliza;
            this.store.montoIva = subtotal * tasaIva;
            this.store.primaTotal = subtotal + this.store.montoIva;
            const periodoPago = parseFloat(this.store.periodoPago) || 1;
            this.store.primaPeriodica = this.store.primaTotal / periodoPago;
        },
    },
};
</script>
